import { expenceStatistics } from 'helpers/fakebackend_helper';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Card, CardBody } from 'reactstrap';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Col, Row } from 'reactstrap';


const ExpenseStat = React.memo(function ExpenseStat() {
  
  const [isMenu, setIsMenu] = useState(false);
  const toggleMenu = () => {
    // setIsMenu(!isMenu);
  };

  const { data, isLoading } = useQuery('expense_stat', expenceStatistics, {
    staleTime: 120000,
    refetchOnWindowFocus: false,
  });
    return (
        <Card>
                <CardBody className="border-bottom">
                  <Dropdown
                    isOpen={isMenu}
                    toggle={toggleMenu}
                    className="float-end ms-2"
                  >
                    <DropdownToggle tag="a" className="text-muted">
                      <i className="mdi mdi-dots-horizontal font-size-18" />
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem href="#">Action</DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>

                  <div>
                    <div className="mb-4 me-3">
                      <i className="mdi mdi-account-circle text-primary h1" />
                    </div>

                    <div>
                      <h5 className="">Total Expnese</h5>
                      <p>{new Date().toLocaleString('default', { month: 'long', year: 'numeric' })}</p>
                      <p className="text-muted mb-1">€ {data?.current_month_total_expense}</p>
                    </div>
                  </div>
                </CardBody>
                <CardBody className="border-bottom">
                  <div>
                    <Row>
                      <Col sm="6">
                        <div>
                          <p className="text-muted mb-2">Last month expense</p>
                          <h5>€ {data?.last_month_total_expense}</h5>
                        </div>
                      </Col>
                      <Col sm="6">
                        <div className="text-sm-end mt-4 mt-sm-0">
                          <p className="text-muted mb-2">Since last month</p>
                          <h5>
                            {data?.current_month_total_expense - data?.last_month_total_expense > 0 ? '+' : '-'} €
                            {Math.abs(data?.current_month_total_expense - data?.last_month_total_expense)?.toFixed(2)}{" "}
                            <span className={data?.current_month_total_expense - data?.last_month_total_expense > 0 ? "badge bg-success ms-1 align-bottom" : "badge bg-danger ms-1 align-bottom"}>
                              {data?.last_month_total_expense === 0 ? 'N/A' : `${((data?.current_month_total_expense - data?.last_month_total_expense) / data?.last_month_total_expense * 100)?.toFixed(1)} %`}
                            </span>
                          </h5>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
    )
})

export default ExpenseStat;